import { useTranslation } from 'next-i18next';

import { useArchivePropertyField } from '@/modules/settings/property/apiHooks';
import { Button, Typography } from '@/shared/components/atoms';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import Archive from '~/images/shared/Archive.svg';
const ArchiveField: React.FC<{
  entityId: number;
  fieldId: number;
  onArchive?: () => void;
}> = ({ entityId, fieldId, onArchive }) => {
  const { t } = useTranslation();

  const { closeModal } = useModal();

  const { mutate, isLoading } = useArchivePropertyField();

  const handleArchive = () => {
    mutate(
      {
        entityId,
        fieldId,
      },
      {
        onSuccess: () => {
          closeModal();
          if (onArchive) onArchive();
        },
      }
    );
  };

  return (
    <div className='flex max-w-md flex-col items-center gap-32 text-center'>
      <div className=' flex h-64 w-64 items-center justify-center rounded-full bg-error-90 text-error-400'>
        <Archive width='40' height='40' />
      </div>
      <div>
        <Typography variant='h2' weight='medium'>
          {t('Are you sure you want to Archive Field?')}
        </Typography>
        <Typography className='mt-8 text-surface-10'>
          {t(
            "You will not be able to undo this step. This field will be archived to manage its operations and data but you won't be able to log new operations to it."
          )}
        </Typography>
      </div>
      <div className='flex w-full gap-24'>
        <Button
          variant='text'
          size='none'
          className='h-56 w-full !rounded-xl border-xs border-outline-default'
          disabled={isLoading}
          onClick={handleArchive}
        >
          {t('Archive')}
        </Button>
        <Button
          size='none'
          className='h-56 w-full !rounded-xl'
          disabled={isLoading}
          onClick={() => closeModal()}
        >
          {t('back')}
        </Button>
      </div>
    </div>
  );
};

export default ArchiveField;
